import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const leaveTypeLocaleModule: LocaleModule = {
  name: "leaveType",
  messages: { en: en, it: it },
};
